import React from "react";
import * as Styles from "./style/ModelResultPriceStyles";
import type { CommonFinanceInfoType, PriceType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { useModelFilterSelector } from "../../../../redux/store";
import {
    getAemMonthlyRateFormat,
    showAemMonthlyRates,
} from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { formatMonthlyFinancePrice } from "../../../../../../shared-logic/utils/priceUtils";
import PriceLabels from "./PriceLabels";

type ModelResultMonthlyPriceType = {
    price: PriceType;
    financeInfo: CommonFinanceInfoType | null;
    modelCode?: string;
};

const ModelResultMonthlyPrice = (props: ModelResultMonthlyPriceType): JSX.Element | null => {
    const { price, financeInfo, modelCode = "" } = props;
    const commonSettings = useModelFilterSelector((state) => state.commonSettings);
    const { hideFinanceTooltip } = commonSettings;

    const monthlyEnabled = showAemMonthlyRates(commonSettings, AemFmComponent.ModelFilter, "new", modelCode);
    if (!monthlyEnabled) return null;

    const monthlyPriceFormat = getAemMonthlyRateFormat(commonSettings, AemFmComponent.ModelFilter, "new", modelCode);

    const { labels = [], secondaryLabels = [] } = financeInfo
        ? formatMonthlyFinancePrice(price, financeInfo, commonSettings, monthlyPriceFormat, undefined, true)
        : { labels: [] };

    const hasSecondaryLabels = secondaryLabels && secondaryLabels.length > 0;

    return (
        <Styles.MonthlyWrapper $flexDirection={hasSecondaryLabels ? "row" : "column"}>
            <PriceLabels
                labels={labels}
                showTooltip={!hasSecondaryLabels}
                financeInfo={financeInfo}
                hideFinanceTooltip={hideFinanceTooltip}
            />
            {hasSecondaryLabels && (
                <>
                    <Styles.Divider>/</Styles.Divider>
                    <PriceLabels
                        labels={secondaryLabels}
                        showTooltip
                        financeInfo={financeInfo}
                        hideFinanceTooltip={hideFinanceTooltip}
                    />
                </>
            )}
        </Styles.MonthlyWrapper>
    );
};

export default ModelResultMonthlyPrice;
